import { FPhi } from '@facephi/selphi-widget-web';
import React, { useState, useEffect } from 'react';
import { DocumentCapture, AssetsType, TrackingSteps, useTracking } from '@facephi/sdk-web';
import { Button } from '@mui/base';
import colors from '../../colors';
import { texts } from '../../general/texts';
import { selectUtilityState } from '../../../features/utilities/utilitySlice';
import { useDispatch, useSelector } from "react-redux";
import { selectGlobalDataState } from '../../../features/global/globalDataSlice';
import { selectRegistrationState } from '../../../features/registration/registrationSlice';
import { sendGeneralRequest } from '../../../features/generalRequest';
import { v4 as uuidv4 } from 'uuid';
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { closeUanatacaDialog } from '../../../features/utilities/utilitySlice';
import CountrySelect from '../../general/uanataca/CountrySelect';
import moment from 'moment';


const SelphID = ({ onDataRetrievement, isUanataca }) => {
  const dispatch = useDispatch()
  const selphIDPath = process.env.PUBLIC_URL + '/widgets/selphid';
  const utilitySliceState = useSelector(selectUtilityState);
  const globalDataSliceState = useSelector(selectGlobalDataState);
  const registrationSliceState = useSelector(selectRegistrationState);
  const [documentType, setDocumentType] = useState(-1);
  const { trackingAsset, trackingEvent, operationId, sessionId } = useTracking();
  const [countryID, setCountryID] = useState('');


  useEffect(() => {
    trackingEvent(TrackingSteps.selphidWidget, TrackingSteps.selphidWidget)
  }, [])

  const removePrefix = (base64String) => {
    if (base64String.startsWith('data:image/jpeg;base64,')) {
      return base64String.slice('data:image/jpeg;base64,'.length);
    }
    return base64String;
  };

  const imageDataToBase64 = (imageData) => {
    const canvas = document.createElement('canvas');
    const context = canvas.getContext('2d');
    canvas.width = imageData.width;
    canvas.height = imageData.height;
    context.putImageData(imageData, 0, 0);
    const base64Data = canvas.toDataURL('image/png');

    return base64Data;
  }

  const showSwal = (message, tryAgain) => {
    showProgress(false)
    withReactContent(Swal).fire({
      title: texts['title-warning'],
      text: message,
      icon: "warning",
      allowOutsideClick: false,
      confirmButtonColor: colors.orange,
      confirmButtonText: texts['try-again']
    }).then(() => {
      if (tryAgain) {
        setDocumentType(-1)
      }
      //onDataRetrievement(null)
    })
  };


  const showProgress = (isProgressing) => {
    if (isProgressing) {
      withReactContent(Swal).fire({
        title: 'Ju lutem prisni..',
        allowOutsideClick: false,
        didOpen: () => {
          withReactContent(Swal).showLoading();
        },
      });
    } else {
      withReactContent(Swal).close();
    }
  }


  const onExtractionFinished = (extractionResult) => {
    // if (documentType === 2 && extractionResult.detail.extractionRaw.mrz.documentId !== extractionResult.detail.extractionRaw.ocr.documentId) {
    //   showSwal(texts["message-id-mismatch"], true)
    // }
    // else if (utilitySliceState.checkFacePhiResponse && extractionResult.detail.extractionRaw.mrz.documentId !== utilitySliceState.checkFacePhiResponse.cardPersonalNo) {
    //   showSwal(texts["message-uanataca-id-mismatch"], true)
    // }

    trackingAsset(extractionResult.detail.images.frontDocument, AssetsType.documentFront)
    trackingAsset(extractionResult.detail.images.backDocument, AssetsType.documentBack)

    const merchantIdScanReference = uuidv4()
    const frontDocument = imageDataToBase64(extractionResult.detail.imagesRaw.frontDocument)
    const backDocument = imageDataToBase64(extractionResult.detail.imagesRaw.backDocument)
    let retries = 0;

    showProgress(true)

    dispatch(sendGeneralRequest({
      request: {
        _request: {
          token: utilitySliceState.isUanatacaDialogOpen || registrationSliceState.isUpgrading ? globalDataSliceState.token : registrationSliceState.token,
          merchantIdScanReference: merchantIdScanReference,
          frontsideImage: frontDocument,
          backsideImage: backDocument,
          country: extractionResult.detail.extractionData.documentCountryIssuer,
          idType: documentType === 2 ? 'ID_CARD' : 'PASSPORT'
        }
      },
      baseUrlKey: "auth",
      endpoint: "Onboarding/StartDocumentValidation"
    })
    )
      .then(response => {
        if (response.payload.response.scanReference) {
          const intervalId = setInterval(() => {
            dispatch(sendGeneralRequest({
              request: {
                _request: {
                  token: utilitySliceState.isUanatacaDialogOpen || registrationSliceState.isUpgrading ? globalDataSliceState.token : registrationSliceState.token,
                  scanReference: response.payload.response.scanReference,
                  type: response.payload.response.type,
                }
              },
              baseUrlKey: "auth",
              endpoint: "Onboarding/StatusDocumentValidation"
            })
            )
              .then(response => {
                if (response.payload.response.success) {
                  showProgress(false)
                  clearInterval(intervalId)
                  AuthenticateFacial(extractionResult, response.payload.response.verification.document.type) 
                  return
                }

                if (response.payload.response.statusFacephi === "PENDING" && ++retries >= 20) {
                  clearInterval(intervalId)
                  showSwal("", true)
                  return
                }

                if (response.payload.response.statusFacephi === "FAILED" || response.payload.response.statusFacephi === "DONE") {
                  clearInterval(intervalId)
                  showSwal("", true)
                }
              })
          }, 3000)
        }
        else if (response.error) {
          showSwal("", true)
        }
      })

  }

  const onExceptionCaptured = () => {
    showSwal(texts["message-cannot-read-id"], true)
  };

  const onExtractionTimeout = () => {
    showSwal(texts["message-cannot-read-id"], true)
  }

  const parseDate = async (input) => {
    const parsedDate = moment(input, "YYMMDD");
    const formattedDate = parsedDate.format("DD/MM/YYYY");
    return formattedDate;
  };

  const AuthenticateFacial = async (extractionResult, responseDocType) => {
    const bDate = await parseDate(extractionResult.detail.extractionData.dateOfBirth)
    const exDate = await parseDate(extractionResult.detail.extractionData.dateOfExpiry)
    showProgress(true)
    dispatch(sendGeneralRequest({
      request: {
        token: utilitySliceState.isUanatacaDialogOpen || registrationSliceState.isUpgrading ? globalDataSliceState.token : registrationSliceState.token,
        tokenFaceImage: registrationSliceState.bestImageTokenized,
        templateRaw: removePrefix(extractionResult.detail.images.frontDocument),
        customerId: globalDataSliceState.username,
        operationId: operationId,
        sessionId: sessionId,
        tenantId: 'e9b039fa-0a2f-4149-9acc-a7e20a46464e',
        personalNr: extractionResult.detail.extractionRaw.mrz.documentId,
        docType: responseDocType, //documentType === 2 ? 'ID' : 'passport', //set docType from StatusDocumentValidation
        nationality: countryID,
        from: "Web",
        extraData: '',
        backsideImage: removePrefix(extractionResult.detail.images.backDocument),
        name: extractionResult.detail.extractionData.firstName,
        surname: extractionResult.detail.extractionData.lastName,
        birthDate: bDate,
        expiryDate: exDate,
        gender: extractionResult.detail.extractionData.gender,
        documentNumber: extractionResult.detail.extractionData.documentNumber
      },
      baseUrlKey: "auth",
      endpoint: "Onboarding/AuthenticateFacial"
    })
    )
      .then(response => {
        showProgress(false)

        if (response.error) {
          if (isUanataca) {
            dispatch(closeUanatacaDialog());
          } else {
            showSwal("", true)
          }
        }
        else {
          onDataRetrievement(extractionResult)
        }
      })
  }

  const handleCountryChange = (selectedCountry) => {
    setCountryID(selectedCountry.code)
  }
  const showAlert = () => {
    withReactContent(Swal).fire({
      title: texts['title-warning'],
      text: 'Ju lutem plotësoni kombësinë.',
      icon: "warning",
      allowOutsideClick: true
    })
  };

  const chooseDocument = (docType) => {
    if (countryID === '') {
      showAlert()
    } else {
      setDocumentType(docType)
    }
  }

  return (
    <>
      {(documentType === -1) && (
        <div style={{ textAlign: 'center' }}>
          <p
            style={{
              marginBottom: '20px',
              fontFamily: 'GerberaBold',
              color: colors.darkBlue
            }}
          >
            {texts["nationality"]}
          </p>
          <div style={{ marginLeft: '80px' }}>
            <CountrySelect onCountryChange={handleCountryChange} isSelphIDStep={true} />
          </div>
          <p
            style={{
              marginTop: '60px',
              marginBottom: '20px',
              fontFamily: 'GerberaBold',
              color: colors.darkBlue
            }}
          >
            {texts["choose-id-or-passport"]}
          </p>
          <Button
            onClick={() => { chooseDocument(2) }}
            style={{
              background: colors.orange,
              cursor: 'pointer',
              color: colors.white,
              margin: '10px',
              padding: '10px',
              borderRadius: '5px',
              borderColor: 'transparent',
              fontFamily: 'GerberaBold',
              textTransform: 'none',
              fontSize: '1rem',
            }}
          >
            {texts["ID"]}
          </Button>
          <Button
            onClick={() => { chooseDocument(3) }}
            style={{
              background: colors.orange,
              cursor: 'pointer',
              color: colors.white,
              padding: '10px',
              width: '146px',
              borderRadius: '5px',
              borderColor: 'transparent',
              fontFamily: 'GerberaBold',
              textTransform: 'none',
              fontSize: '1rem'
            }}
          >
            {texts["passport"]}
          </Button>
        </div>
      )}

      {(documentType !== -1) && (
        <DocumentCapture
          className={'Facephi'}
          bundlePath={selphIDPath}
          language='al'
          externalCamera={false}
          licenseKey={'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'}
          onExtractionFinish={((extractionResult) => onExtractionFinished(extractionResult))}
          onExceptionCaptured={(event) => onExceptionCaptured(event.detail)}
          onExtractionTimeout={(event) => onExtractionTimeout(event)}
          cameraWidth={720}
          cameraHeight={1280}
          documentType={documentType === 2 ? 2 : (documentType === 3 ? 3 : 0)}  
        />
      )}
    </>
  )
}
export default SelphID;

//testing license
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

//production
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